export enum MeasurementSystemMode {
  Imperial = "imperial",
  Metric = "metric",
}
